import React, { useContext, useState, useEffect } from "react";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { citizenBaseUrl } from "@egovernments/digit-ui-module-core/src/pages/citizen/citizenPageUrls";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import useDepartmentSelector from "../../citizen/TCPForms/hooks/useDepartmentSelector";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
// import { use } from "react";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const useEmpFar = (formData, workflowDetails, userRolesArray) => {
  let user = Digit.UserService.getUser();
  console.log("user", user);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const { documentRemarksData, handleGetDocumentById } = useContext(ScrutinyRemarksContext);
  const [documentRemarksData, handleGetDocumentById] = useState([]);
  const stateId = Digit.ULBService.getStateId();
  const { info: userInfo = {} } = Digit.UserService.getUser();
  const appType = formData?.applicationType;
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const history = useHistory();
  const applicationData = formData;
  // const { documentRemarksData } = useContext(ScrutinyRemarksContext);
  const [isUserEligible, setIsUserEligible] = useState(true);
  const [currentAction, setCurrentAction] = useState(null);
  const [currentTab, setCurrentTab] = useState("0");
  const [currentView, setCurrentView] = useState("documents");
  const [remarksData, setRemarksData] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [developerRemarksValidation, setDeveloperRemarksValidation] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.documents);
  const [purchasableFarActions, setPurchasableFarActions] = useState(null);
  const [mandatoryCondition, setMandatoryCondition] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [reviewedData, setReviewedData] = useState(formData?.checklistReview);
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [assignLTP, setAssignLTP] = useState("No");
  const [structureCertificateError, setStructureCertificateError] = useState(null);
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState("");
  const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [initialUrl, setInitialUrl] = useState("");
  const userInfos = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEE = userRolesArray?.[0]?.code === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const isDa = formData?.department === "DA";
  const isCitizen = user?.info?.type === "CITIZEN";
  const Modal = useModal();
  const [showToast, setShowToast] = useState(null);
  const closeToast = () => setShowToast(null);
  const isPurchasableFAR = appType === "FORM_PURCHASABLE_FAR";
  const updatePurchasableFar = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  const [iframeSrc, setIframeSrc] = useState("");
  const docs = formData?.documents || {};
  let applicationDocs = [];
  let consumerCode = formData?.applicationNo;
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_FAR", formData);
  const fetchBillParams = { consumerCode };
  const { data: cities, isLoading } = Digit.Hooks.useTenants();
  const { data: { BPA: { ProposedActivityPurchasableFAR: pFarList } = {} } = {}, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["ProposedActivityPurchasableFAR"]
  );
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { authority, plan, form, year, serial, formType } = useParams();
  const filterOfficeNames = (completeList) => {
    const officeNames = completeList.map((office) => ({ value: office.name, label: office.name }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  };
  const isAssignedLTP = userInfo?.name === params?.professionalInformation?.ltpName;
  console.log("isAssignedLTP", isAssignedLTP);
  const approvedLandUseData = useSelector((state) => state.approvedLandUseData);
  const approvedLayout = applicationData?.descriptionOfLand?.schemeType === "Scheme" ? "Yes" : "No";

  const avpAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district?.code?.includes("up.avp"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];

  const daAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district?.code?.includes("up.da"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];

  const officesList = applicationFlow === "DA" ? filterOfficeNames(daAuthorityList) : filterOfficeNames(avpAuthorityList);

  const [farDetails, setFarDetails] = useState({
    baseFar: formData?.descriptionOfLand?.properties?.[0]?.baseFar || 0,
    circleRate: formData?.descriptionOfLand?.properties?.[0]?.circleRate || 0,
  });

  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let improvedDoc = [];

  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result)); // or result.toString()
    return String(result); // Convert the result to a string before returning
  };

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });

  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }

  console.log("APPLICATIONDATA", formData);

  const userRoles = user?.info?.roles?.map((e) => e.code);

  const documentSection = formData?.documents?.filter((doc) => !["signature", "applicantPhoto"].includes(doc.documentType));
  const squareMeterArea = formData?.descriptionOfLand.properties?.[0].plotArea;

  let isbelowEE = squareMeterArea < 501;
  let isbelowEEAVP = squareMeterArea < 0;
  let isbelowTP = squareMeterArea < 501;
  let isbelowCTP = squareMeterArea < 2001;
  let isbelowVC = squareMeterArea > 2000;

  let isbelowNCTP = squareMeterArea < 501;
  let isbelowNVC = squareMeterArea > 500;
  let isbelowNVCNO = squareMeterArea > 0;
  // -----------------------------------------------

  // const isEE = userRoles.includes("EE");
  const isTP = userRoles.includes("TP");
  const isCTP = userRoles.includes("CTP");
  const isVC = userRoles.includes("Vice_Chairman");
  // const empactions = workflowDetails?.data?.nextActions;
  console.log("workFlowDetails", workflowDetails);
  let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    if (formData?.approvedLayout === "Yes" && formData?.businessService != "BPA_FAR_AVP") {
      if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
        if (isbelowTP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowTP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEE && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEE &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowCTP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowVC &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      } else if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVCNO &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      } else if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNCTP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVC &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      }
    } else if (formData?.approvedLayout === "No" && formData?.businessService != "BPA_FAR_AVP") {
      if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isEE &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowEEAVP &&
          isCTP &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (
          !isbelowNVCNO &&
          isVC &&
          (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")
        ) {
          return false;
        }
      }
    }
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });

  async function purchasableFarSubmit() {
    const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");
    console.log({ isDocValidated, updatedDocuments }, "uspspsp");
    if (userRolesArray?.[0]?.code === "JE" && (farDetails.circleRate == 0 || farDetails.circleRate == null)) {
      Modal("Circle rate is required", "Please enter circle rate in the FAR details section.", "error");
      return;
    }
    if (!isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return;
    }
    const additionalDetails = {
      ...applicationData?.additionalDetails,
    };
    const workflow = {
      action: purchasableFarActions?.action,
      comment: remarksData
        ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      comments: remarksData
        ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile
        ? [
            {
              documentType: purchasableFarActions + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const appData = {
      ...applicationData,
      documents: updatedDocuments,
      additionalDetails,
      checklist: formData?.checklist,

      checklistReview: reviewedData,
      descriptionOfLand: {
        properties: [{ ...applicationData?.descriptionOfLand?.properties?.[0], baseFAR: farDetails.baseFar, circleRate: farDetails.circleRate }],
      },
      tenantId: "up",
      workflow,
      action: purchasableFarActions?.action,
      comment: remarksData
        ? `<br> ${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray?.[0]?.name}.<b>`
        : developerRemarks,
      // approvalLetterId: structureCertificateId,
      // approvalLetterUrl: structureCertificateUrl,
      assignee: null,
      wfDocuments: uploadedFile
        ? [
            {
              documentType: purchasableFarActions + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const data = { ...appData };
    console.log("farPayloadUpdate", data);

    await updatePurchasableFar.mutate(
      { PurchasableFAR: data },
      {
        onSuccess: async (result) => {
          if (result?.PurchasableFAR?.[0]?.applicationNo) {
            Modal(`Remarks Added`, `Remarks for <strong>${formData?.applicationNo}</strong> added successfully!`, "success", "/digit-ui/employee");
          }
          Digit?.SessionStorage?.del("isDocValidated");
        },
      }
    );
  }
  const handleNoWorkflow = (updatedDocuments) => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      documents: updatedDocuments,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updatePurchasableFar.mutate(
      { PurchasableFAR: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          setDeveloperUpdateDocument("DocumentDetailsUpdated");
          onSelect("", result?.PurchasableFAR?.[0]);
          // const isDocValidated = result?.PurchasableFAR?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          const isDocValidated = result?.PurchasableFAR?.[0]?.documents?.every((item) => !item.isMandatory || item.documentRemarks !== null);
          Digit?.SessionStorage.set("isDocValidated", isDocValidated); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          // Modal(`Documents updated`, `Documents details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };

  // inspectionReportData API Call
  const callDocumentDetailsAPI = async () => {
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfos,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfos?.id || null,
          name: userInfos?.name || null,
          employeeName: userInfos?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "DocumentDetails",
        documentDetails: {
          dataRecommendation: dataRecommendationDocument,
          developerRemarks: developerRemarksDocument,
          documents: updatedDocuments,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetDocumentById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  const handleRemarksValidation = () => {
    console.log("handleRenarksCalled");

    const stripHtmlTags = (html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
    };

    const plainText = stripHtmlTags(developerRemarks);
    if (plainText.trim().length === 0) {
      setDeveloperRemarksValidation("Developer remarks cannot be empty.");
    } else {
      setDeveloperRemarksValidation("Valid remarks entered");
    }
  };

  // useEffect(() => {
  //   if (
  //     dataRecommendationDocument &&
  //     developerRemarksDocument &&
  //     updatedDocuments?.filter((doc) => doc.isMandatory)[0]?.documentRemarks &&
  //     developerUpdateDocument === "DocumentDetailsUpdated"
  //   ) {
  //     console.log(
  //       "inside useEffect",
  //       dataRecommendationDocument,
  //       developerRemarksDocument,
  //       updatedDocuments?.[0]?.documentRemarks,
  //       developerUpdateDocument
  //     );

  //     callDocumentDetailsAPI();
  //   }
  // }, [dataRecommendationDocument, developerRemarksDocument, updatedDocuments?.[0]?.documentRemarks, developerUpdateDocument]);

  useEffect(() => {
    handleRemarksValidation();
  }, [developerRemarks]);
  useEffect(() => {
    // const isDocValidated = formData?.documents?.some((item) => item.documentRemarks !== null);
    const isDocValidated = formData?.documents?.every((item) => !item.isMandatory || item.documentRemarks !== null);
    if (isDocValidated) {
      Digit?.SessionStorage.set("isDocValidated", isDocValidated);
    }
  }, []);
  const onRadioActionSelect = (value) => {
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
  };

  async function ownerSubmit() {
    if (currentAction?.action === "ISSUE_CERTIFICATE") {
      onActionSelect(currentAction);
    }
    const additionalDetails = {
      ...applicationData?.additionalDetails,
      fieldinspection_pending: getfeildInspection(applicationData),
      pendingapproval: getPendingApprovals() || [],
    };
    const workflow = {
      action: currentAction?.action,
      comment: developerRemarks,
      comments: developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const appData = {
      ...applicationData,
      documents: formData?.documents,
      additionalDetails,
      checklist: selectChecklist,
      workflow,
      action: currentAction?.action,
      comment: developerRemarks,
      // approvalLetterId: structureCertificateId,
      // approvalLetterUrl: structureCertificateUrl,
      assignee: null,
      wfDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const data = { ...appData };
    await updateOwnerCall.mutate(
      { ownerRegistration: data },
      {
        onSuccess: async (result) => {
          if (result?.ownerRegistration?.[0]?.applicationNo) {
            let action = "";
            if (currentAction?.action === "APPROVED") {
              action = "Approved";
            } else if (currentAction?.action === "REJECT") {
              action = "Rejected";
            } else if (currentAction?.action === "SENDBACK_TO_APPLICANT") {
              action = "Sent to Applicant";
            } else if (currentAction?.action === "FORWARD_TO_LA_OFFICER") {
              action = "Forwarded to LA Officer";
            } else if (currentAction?.action === "FORWARD_TO_PROVISIONAL_APPROVED") {
              action = "Provisionally Approved";
            } else if (currentAction?.action === "SENDBACK_TO_EXECUTIVE_ENGINEER") {
              action = "Sent to Executive Engineer";
            } else if (currentAction?.action === "APPROVE") {
              action = "Approved";
            }
            Modal(
              `Application ${t(action)}`,
              `Application <strong>(${formData?.applicationNo}) ${t(action)}</strong>Successfully!`,
              "success",
              "/digit-ui/employee"
            );
          }
        },
      }
    );
  }

  const onDropDownSelect = (event) => {
    const value = event.target.value;
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const handleDocView = () => {
    setCurrentView((prev) => (prev === "documents" ? "viewDocuments" : "documents"));
  };
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };

  // console.log("documentRemarksData", documentRemarksData);

  return {
    stateId,
    user,
    appType,
    BusinessService,
    docs,
    documents,
    consumerCode,
    farDetails,
    fetchBillParams,
    isPurchasableFAR,
    currentAction,
    setCurrentAction,
    setFarDetails,
    handleChange,
    purchasableFarSubmit,
    currentTab,
    Modal,
    tenantId,
    updatedDocuments,
    setUpdatedDocuments,
    paymentDetails,
    totalAmount,
    isCitizen,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    applicationDocs,
    mandatoryCondition,
    setMandatoryCondition,
    onRadioActionSelect,
    actions,
    uploadedFile,
    setUploadedFile,
    documentSection,
    userRoles,
    showToast,
    setShowToast,
    closeToast,
    remarksData,
    setRemarksData,
    purchasableFarActions,
    handleRemarksValidation,
    developerRemarks,
    setDeveloperRemarks,
    developerRemarksValidation,
    setDeveloperRemarksValidation,
    ownerSubmit,
    structureCertificateError,
    setPurchasableFarActions,
    setReviewedData,
    onDropDownSelect,
    dispatch,
    isUserEligible,
    setIsUserEligible,
    isAssignedLTP,
    officesList,
    applicationFlow,
    params,
    approvedLandUseData,
    approvedLayout,
    assignLTP,
    setAssignLTP,
    pFarList,
    currentView,
    handleDocView,
    // documentRemarksData,
    isPreviewLoading,
    setIsPreviewLoading,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    setDeveloperRemarksDocument,
    developerRemarksDocument,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    loader,
    setInitialUrl,
    handleNoWorkflow,
    dataRecommendation,
    setDataRecommendation,
    developerUpdateDocument,
    documentRemarksData,
    callDocumentDetailsAPI,
    params,
    setParams,
    clearParams,
  };
};
export default useEmpFar;
